import React from 'react';
import {Switch} from 'react-router-dom';
import {useIntl} from 'react-intl';

import PrivateRoute from '../../components/PrivateRoute';
import withLayout from '../../components/ui/Layout';
import CityList from './CityList';
import CityDetail from './CityDetail';
import CreateCity from './CreateCity';
import EditCity from './EditCity';

function Cities() {
    const intl = useIntl();

    return (
        <Switch data-test='citiesComponent'>
            <PrivateRoute
                permission='CITIES_INDEX'
                exact
                path='/cities'
                component={withLayout(
                    CityList,
                    intl.formatMessage({id: 'ROUTES.CITIES.INDEX'}),
                )}
            />
            <PrivateRoute
                permission='CITIES_CREATE'
                exact
                path='/cities/create'
                component={withLayout(
                    CreateCity,
                    intl.formatMessage({id: 'ROUTES.CITIES.CREATE'}),
                )}
            />
            <PrivateRoute
                permission='CITIES_EDIT'
                exact
                path='/cities/:id/edit'
                component={withLayout(
                    EditCity,
                    intl.formatMessage({id: 'ROUTES.CITIES.EDIT'}),
                )}
            />
            <PrivateRoute
                permission='CITIES_SHOW'
                exact
                path='/cities/:id'
                component={withLayout(
                    CityDetail,
                    intl.formatMessage({id: 'ROUTES.CITIES.SHOW'}),
                )}
            />
        </Switch>
    );
}

export default Cities;
